(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }


    // declare swipers
    let thumbsSwiper = null;
    let productSwiper = null;

    if (section.querySelector('.productVisual').classList.contains('multiVariants')) {
        /* thumbs */
        section.querySelectorAll('.productVisualThumbs').forEach(swiper => {
                new Swiper(swiper, {
                    slidesPerView: 5,
                    spaceBetween: 10,
                    observer: true, // Listens for changes in the Swiper container,
                    observeParents: true,
                    observeSlideChildren: true, // Listens for changes in slide children
                });
            }
        )

        const thumbSlides = document.querySelectorAll('.productVisualThumbsSlide');


        // override the thumb click functionality to target the right main swiper
        thumbSlides.forEach((slide) => {
            slide.addEventListener('click', () => {
                // Slide on main swiper to correct position, accounting for hidden slides
                const productVisualSwiper = slide.closest('.productVisualItem').querySelector('.productVisualSwiper');
                let hiddenSlides = productVisualSwiper.querySelectorAll('.productVisualSwiperSlide.mainVar:not(.currentSlide)').length;

                // If main (variant) slide, do NOT add hidden slides count and slide to its position directly (first slide)
                if (slide.classList.contains('mainVar')) {
                    productVisualSwiper.swiper.slideTo(0, 250);
                    return;
                }

                // calculate target index
                const targetIndex = Number(slide.dataset.position) - 1 - (hiddenSlides ? hiddenSlides : 0);

                // slide to the target index
                productVisualSwiper.swiper.slideTo(targetIndex);
            });
        });

        /* swipers */
        section.querySelectorAll('.productVisualSwiper').forEach(swiper => {
            let parent = swiper.closest('.productVisualItem');
            new Swiper(swiper, {
                slidesPerView: 1,
                spaceBetween: 60,
                centeredSlides: true,
                observeParents: true,
                observer: true, // Listens for changes in the Swiper container,
                observeSlideChildren: true, // Listens for changes in slide children
                breakpoints: {
                    0: {
                        slidesPerView: 1.3,
                        spaceBetween: 14
                    },
                    801: {
                        slidesPerView: 1,
                        spaceBetween: 60
                    }
                },
                navigation: {
                    nextEl: parent.querySelector('.swiper-button-next'),
                    prevEl: parent.querySelector('.swiper-button-prev')
                },
                on: {
                    slideChange: function () {
                        if (!swiper.querySelector(".productVisualSwiperSlide")) {
                            return;
                        }
                        // pause all videos
                        section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                            element.pause();
                        });
                    }
                },
            });
        })
    } else {
        /* thumbs */
        thumbsSwiper = new Swiper(section.querySelector('.productVisualThumbs'), {
            slidesPerView: 5,
            spaceBetween: 10,
        })

        /* main swiper */
        productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: true,
            breakpoints: {
                0: {
                    slidesPerView: 1.3,
                    spaceBetween: 14
                },
                801: {
                    slidesPerView: 1,
                    spaceBetween: 20
                }
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev')
            },
            on: {
                slideChange: function () {
                    if (!section.querySelector(".productVisualSwiperSlide")) {
                        return;
                    }

                    // pause all videos
                    section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                        element.pause();
                    });
                }
            }
        });
    }

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {

            // remove active from all labels without a checked input
            section.querySelectorAll('.productOptionsItemValuesItem .productOptionsItemValuesItemLabelInput:not(:checked)').forEach(item => {
                item.closest('.productOptionsItemValuesItem')?.classList.remove("active");
            })

            // setup active functionality for multi variant class (if flavor option)
            if (section.querySelector('.productVisual').classList.contains('multiVariants') && element.dataset.type === 'Flavor') {
                // remove active from all classes not needed
                section.querySelectorAll(`.productVisualItem:not([data-type="${element.value}"])`).forEach(item => item.classList.remove("active"));
                // set active to needed classes
                section.querySelector(`.productVisualItem[data-type="${element.value}"]`)?.classList.add("active");
            }

            // add active to only the elements who have checked inputs
            this.closest(".productOptionsItemValuesItem")?.classList.add('active');
            // update product
            updateProduct().catch(e => console.error(e));
            // update option
            updateOption().catch(e => console.error(e));
        });
    })

    /**************
     Update Product
     ***************/


    section.querySelectorAll('.productDropdownsItemTitle').forEach(element => {
        element.addEventListener("click", function () {
            let parent = element.closest('.productDropdownsItem');

            // remove active if already active
            if (parent.classList.contains('active')) {
                parent.classList.remove('active');
                return;
            }
            // close all other dropdowns
            section.querySelectorAll('.productDropdownsItem').forEach(item => item.classList.remove('active'));
            // open this dropdown
            parent.classList.add('active');
        })
    })

    async function updateProduct() {
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            let options = [];

            // collect options from inputs
            section.querySelectorAll(".productOptionsItem").forEach(option => {
                options.push(option.querySelector(`input:checked`).value);
            })

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });

            // check if variant wasn't found
            if (!activeVariant) {
                section.querySelector(".productATC").disabled = true;
                section.querySelector(".productATCText").textContent = "Not Available";
                return;
            }

            /**************
             Variant Image
             ***************/

            if (activeVariant.featured_image && productSwiper != null) {
                // change active slide
                productSwiper.slideTo(activeVariant.featured_image.position - 1);
            } else if (activeVariant.featured_image && section.querySelector('.productVisual').classList.contains('multiVariants')) {
                // find the right visual item
                let parentEl = section.querySelector('.productVisualItem.active');

                // get number of main (variant) slides
                let mainSlides = parentEl.querySelectorAll('.productVisualSwiperSlide.mainVar').length;

                // change active slide to active variant image
                parentEl.querySelector('.swiper')?.swiper?.slideTo(0, 500);

                // show the thumbnail and slide of the active variant and hide others
                parentEl.querySelectorAll('.productVisualThumbsSlide.mainVar, .productVisualSwiperSlide.mainVar').forEach(slide => {
                    if (parseInt(slide.dataset.position) === activeVariant.featured_image.position % mainSlides ||
                        (activeVariant.featured_image.position % mainSlides) === 0 && parseInt(slide.dataset.position) === mainSlides) {
                        slide.classList.add('currentSlide');
                    } else {
                        slide.classList.remove('currentSlide');
                    }
                });

                // update swiper
                parentEl.querySelector('.swiper')?.swiper?.update();
            }

            /**************
             Price
             ***************/

            // if there's a subscription we need to update price to buy now otp pricing
            // also need to update the subscription benefit bullets
            if (activeVariant.selling_plan_allocations.length > 0) {

                // update subscription frquency benefit
                if (section.querySelector('.productOptionsItemIncludes')) {

                    // check if we've got the plan name
                    if (variantIDToSellingPlanName[activeVariant.id]) {
                        // get the selling plan name
                        let planName = (variantIDToSellingPlanName[activeVariant.id].match(/^.*?month/)?.[0] || '').trim();

                        // get the elements we'll be updating
                        const perDay = section.querySelector('.productOptionsItemIncludesItemsItem.perDay');
                        const frequency = section.querySelector('.productOptionsItemIncludesItemsItem.frequency')

                        // determine the cost per day (if given per pack quantity)
                        let cadence = (planName.trim() === 'month' ? 1 : parseInt((planName).match(/\d+/g)));
                        let perDayCost = 0;

                        // if no given metafield, hide perday item
                        if (perPack === 0) {
                            perDay.classList.add('hidden')
                        } else {
                            perDayCost = price(((activeVariant.selling_plan_allocations[0].price / (perPack * cadence))).toFixed(2));
                            perDay.classList.remove('hidden')
                        }

                        // adjust grammar for 1 month delivery vs other deliveries
                        let planFrequency = cadence === 1 ? planName.replace('1 month', '1-month') : planName.replace('month', 'months');

                        // update the price per day
                        perDay.innerHTML = `
                        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.6144 0H9.80532C9.7056 0 8.5888 0 7.37892 0C7.65812 0.306291 7.90408 0.886287 8.15005 1.23168C8.60874 1.9746 9.15385 2.69796 9.566 3.47998C10.0845 4.43144 10.3504 5.50671 9.89839 6.50379C9.35328 7.8658 7.39886 8.63479 5.84331 7.99614C5.05223 7.68985 4.434 7.0903 4.1548 6.40603C3.47009 4.67256 4.84615 2.96515 5.78348 1.48583C5.84995 1.38157 5.91643 1.28381 5.98291 1.17954C6.20228 0.847187 6.44824 0.299774 6.71415 0C5.47104 0 4.30105 0 4.20133 0H0.392213C0.17284 0 0 0.175954 0 0.384492V8.04176C0 10.7137 1.88794 12.1213 4.20798 12.6882C6.16239 13.1705 8.41596 13.0532 10.1045 12.61C12.2716 12.0366 14 10.3226 14 8.04176V0.384492C14 0.169437 13.8205 0 13.6078 0H13.6144Z" fill="#21C1D5"/>
                         </svg>
                            A hydrated dog for <span>${perDayCost} per day!</span>
                    `
                        // update the delivered every month text
                        frequency.innerHTML = `
                        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                           <path d="M13.6144 0H9.80532C9.7056 0 8.5888 0 7.37892 0C7.65812 0.306291 7.90408 0.886287 8.15005 1.23168C8.60874 1.9746 9.15385 2.69796 9.566 3.47998C10.0845 4.43144 10.3504 5.50671 9.89839 6.50379C9.35328 7.8658 7.39886 8.63479 5.84331 7.99614C5.05223 7.68985 4.434 7.0903 4.1548 6.40603C3.47009 4.67256 4.84615 2.96515 5.78348 1.48583C5.84995 1.38157 5.91643 1.28381 5.98291 1.17954C6.20228 0.847187 6.44824 0.299774 6.71415 0C5.47104 0 4.30105 0 4.20133 0H0.392213C0.17284 0 0 0.175954 0 0.384492V8.04176C0 10.7137 1.88794 12.1213 4.20798 12.6882C6.16239 13.1705 8.41596 13.0532 10.1045 12.61C12.2716 12.0366 14 10.3226 14 8.04176V0.384492C14 0.169437 13.8205 0 13.6078 0H13.6144Z" fill="#21C1D5"/>
                        </svg>
                        
                        A ${planFrequency.replace(' months', '-month')} supply delivered every ${planFrequency.replace('-month', ' month')}`;
                    }
                }
            } else {
                // hide the buy once element if no selling plan
                section.querySelector('.productBuy').classList.remove("active");
            }
        }


        /***********
         Ingredients Chart Item
         ************/


        // hide all the ingredient variant containers
        section.querySelectorAll('.prodChartInnerItem.ingredient').forEach(item => item.classList.remove('active'));
        // show the active variant container
        const activeIngredientsContainers = section.querySelectorAll(`.prodChartInnerItem.ingredient[data-variant-id='${activeVariant.id}']`);
        const parentEls = section.querySelectorAll('.prodChartInnerItemIngredients');
        if (activeIngredientsContainers.length > 0) {
            // show parents if needed
            parentEls.forEach(parent => parent.classList.add('visible'));
            // show all active ingredient containers for this variant
            activeIngredientsContainers.forEach(container => container.classList.add('active'));
        } else {
            // if no active ingredient variant container, hide the parents
            parentEls.forEach(parent => parent.classList.remove('visible'));
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productATC").disabled = false;
            section.querySelector(".productATCText").textContent = "Add To Cart";
        } else {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATCText").textContent = "Sold Out";
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    async function updateOption() {
        section.querySelectorAll(".productOptionsItemValuesItem").forEach(option => {

            // get the active variant
            let variant = variantIDToProduct[option.querySelector('input').dataset.variantId];

            // check if variant has been found
            if (!variant) {
                return;
            }
            // if there's a subscription we need to update price on the options

            if (option.closest('.productOptionsItem').classList.contains('container')) {
                // get the real and compare els if they exist
                const realEl = option.querySelector('.productOptionsItemValuesItemRightPriceReal');
                const compareEl = option.querySelector('.productOptionsItemValuesItemRightPriceCompare');

                if (variant.selling_plan_allocations.length > 0) {

                    //  get the months from the selling plan name
                    const planName = variantIDToSellingPlanName[variant.id];
                    const numMonths = planName ? (planName.match(/\d+/g)?.[0] || '1') : '1';


                    // declare compare and real price
                    const realPrice = variant.selling_plan_allocations[0].price;
                    const comparePrice = variant.selling_plan_allocations[0].compare_at_price;

                    // update real pricing
                    realEl.textContent = price(Math.floor(realPrice / numMonths) * 100 / 100) + '/mo';

                    // update compare pricing (if applicable)
                    if (comparePrice > realPrice) {
                        compareEl.textContent = price(Math.floor(comparePrice / numMonths) * 100 / 100) + '/mo';
                    }

                } else {
                    // Non-subscription scenario
                    const realPrice = variant.price;
                    const comparePrice = variant.compare_at_price;

                    if (comparePrice > realPrice) {
                        compareEl.textContent = price(comparePrice);
                    }
                    realEl.textContent = price(realPrice);
                }
            }

        })
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    document.addEventListener('DOMContentLoaded', function () {
        updateProduct().catch(e => console.error(e));
        updateOption().catch(e => console.error(e));
    })

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan and if this isn't the otp button
        if (activeVariant.selling_plan_allocations.length > 0 && this.dataset?.plan !== 'otp') {
            formData.items[0].selling_plan = activeVariant.selling_plan_allocations[0].selling_plan_id;
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelectorAll('.productATC, .productBuy').forEach(button => {
        button.addEventListener("click", addToCart);
    })
}());